import { MobileHomePreview } from "./mobile-home-preview";
import { MobileManagedByPreview } from "./mobile-managed-by-preview";
import { PHONE_HEIGHT, PHONE_WIDTH } from "./phone-frame";
import { PreviewDialog } from "./preview-dialog";
import { BrandingPreviewValues } from "./types";

const PHONE_GAP = 48;

type MobileAppDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  previewValues: BrandingPreviewValues;
};

export function MobileAppDialog({
  open,
  onOpenChange,
  previewValues,
}: MobileAppDialogProps) {
  return (
    <PreviewDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Mobile app"
      description="How your brand appears to clients in the mobile app"
      width={PHONE_WIDTH * 2 + PHONE_GAP}
      height={PHONE_HEIGHT}
    >
      <div className="flex" style={{ gap: PHONE_GAP }}>
        <MobileHomePreview {...previewValues} />
        <MobileManagedByPreview {...previewValues} />
      </div>
    </PreviewDialog>
  );
}
